import styled from 'styled-components';
import LinkBranded from 'src/elements/links/2023_Q4/LinkBranded';
import { layout } from 'src/styles/layout';

export const LinkBrandedLargeStyles = styled(LinkBranded)`
  padding: 1.1875rem 2.5rem;
  width: fit-content;

  @media (max-width: ${layout.xs}) {
    padding: 1.1875rem 1.6rem;
  }
`;
